import { gql } from '@apollo/client'

const STUDY_SCHEDULE_FIELDS = gql`
  fragment StudyScheduleFields on StudyScheduleType {
    id
    createdAt
    updatedAt
    deletedAt
    version
    title
    description
    week8url
    week8settingsTitle
    week8settingsDescription
    week10url
    week10settingsTitle
    week10settingsDescription
    week12url
    week12settingsTitle
    week12settingsDescription
  }
`

export const FIND_STUDY_SCHEDULE = gql`
  ${STUDY_SCHEDULE_FIELDS}
  query findStudySchedule($platformId: String!) {
    findStudySchedule(platformId: $platformId) {
      ...StudyScheduleFields
    }
  }
`

export const UPDATE_STUDY_SCHEDULE = gql`
  ${STUDY_SCHEDULE_FIELDS}
  mutation updateStudySchedule($updateStudyScheduleInputFieldName: UpdateStudyScheduleInput!) {
    updateStudySchedule(updateStudyScheduleInputFieldName: $updateStudyScheduleInputFieldName) {
      ...StudyScheduleFields
    }
  }
`
